import React from "react"
import { EmissaoCupomFiscalContextProvider } from "./context/EmissaoCupomFiscalContextProvider"
import { EmissaoCupomFiscal } from "./EmissaoCupomFiscal"

export function Index() {
    return (
        <EmissaoCupomFiscalContextProvider>
            <EmissaoCupomFiscal />
        </EmissaoCupomFiscalContextProvider>
    )
}
